__webpack_require__.p = "/typo3conf/ext/mw_sitepackage/Resources/Public/Assets/";